module.exports = __webpack_public_path__ + "img/04_Deine_Vorteile.2583dc9e.svg";